
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Herbert_classification_of_scaphoid_fracture',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Herbert_classification_of_scaphoid_fracture.vue